import { createSelector } from 'reselect'
import confirmTypes from 'helpers/enums/confirmTypes'
import { localize } from 'helpers/translator'
import studentSlideTimerSelector from 'redux/selectors/student/timer'
import { sessionTypesWithNoSubmit, sessionTypesWithSubmitDisabled } from 'helpers/session/submitOptions'
import featureFlagsSelectorCreator from 'redux/selectors/feature_flags/feature_flags_selector'
import featureFlagsTypes from 'helpers/enums/featureFlagsTypes'

const featureFlagsSelector = featureFlagsSelectorCreator([
	featureFlagsTypes.RICH_TEXT_STUDENT_SESSION,
])

const getStudentViewData = state => state.student
const getConfirmsData = state => state.confirm
const getSlideId = (state, props) => props.session.session_uid + '_' + props.slide.slideId

const buildConfirmTexts = (confirmType, answers) => {
	let confirmTexts

	if (!answers.length) {
		if (confirmType === confirmTypes.STUDENT_SUBMIT_POLL_EMPTY_ANSWERS_REQUIRED) {
			confirmTexts = {
				mainText: localize('poll_submit_required_text'),
				actionTwoText: localize('action_button_gotit_cancel'),
			}
		} else {
			confirmTexts = {
				mainText: localize('poll_submit_confirm_empty_text'),
				actionOneText: localize('poll_submit_confirm_empty_actionone_text'),
				actionTwoText: localize('poll_submit_confirmed_empty_actiontwo_text'),
			}
		}
	}
	return confirmTexts
}

const getStudentSlideData = createSelector(
	[
		getStudentViewData,
		getConfirmsData,
		studentSlideTimerSelector,
		getSlideId,
		featureFlagsSelector,
	],
	(student, confirms, timer, slideId, featureFlags) => {
		const slide_data = student.slides[slideId]
		let footer_message = '', confirm
		let isImmersiveReaderEnabled = false

		if (slide_data) {
			const no_answers_message = slide_data.canMultiSelect ?
				localize('student_slide_selector_multianswer_text') :
				localize('student_slide_selector_oneanswer_text')
			footer_message = slide_data.answers && slide_data.answers.length > 0 ?
				`${slide_data.answers.length} ` + localize('student_slide_selector_selected_text') :
				no_answers_message
			isImmersiveReaderEnabled = slide_data.shouldShowImmersiveReader
		}

		if (confirms.length) {
			const confirmsArray = [
				confirmTypes.STUDENT_SUBMIT_POLL_EMPTY_ANSWERS_CONFIRM,
				confirmTypes.STUDENT_SUBMIT_POLL_EMPTY_ANSWERS_REQUIRED,
				confirmTypes.STUDENT_SUBMIT_POLL_CONFIRMED,
				confirmTypes.STUDENT_SUBMIT_FAILED_CONFIRM,
			]
			const confirmType = confirms.length && confirmsArray.includes(confirms[0].confirmType) ?
				confirms[0].confirmType :
				null

			if (confirmType) {
				const confirmTexts = buildConfirmTexts(confirmType, slide_data.answers)
				confirm = { type: confirmType, ...confirmTexts }
			}
		}

		return {
			slide_data,
			confirm,
			footer_message,
			timer,
			isSubmitHidden: sessionTypesWithNoSubmit.includes(student.sessionType),
			isSubmitDisabled: sessionTypesWithSubmitDisabled.includes(student.sessionType),
			shouldShowImmersiveReader: isImmersiveReaderEnabled,
			shouldShowHTMLComponent: featureFlags[featureFlagsTypes.RICH_TEXT_STUDENT_SESSION],
		}
	}
)
export default getStudentSlideData
